export const setRequisicoes = ({ commit }, payload) => {
  commit('SET_REQUISICOES', payload)
}

export const setRequisicoesLoading = ({ commit }, payload) => {
  commit('SET_REQUISICOES_LOADING', payload)
}

export const updateRequisicao = ({ commit }, payload) => {
  commit('UPDATE_REQUISICAO', payload)
}

export const setActivePolling = ({ commit }, payload) => {
  commit('SET_ACTIVE_POLLING', payload)
}

export const removeActivePolling = ({ commit }, requestId) => {
  commit('REMOVE_ACTIVE_POLLING', requestId)
}
